<template>
  <div>
    <wx-open-launch-weapp id="launch-btn"> </wx-open-launch-weapp>
  </div>
</template>

<script>
import { getWXAuthInfor } from "../../api/home";
export default {
  data() {
    return {};
  },

  mounted() {
    const cookie = document.cookie;
    const encodedCookie = encodeURIComponent(cookie);
    let launchBtn = document.getElementById("launch-btn");
    let myPath = `pages/test/index?cookie=${encodedCookie}`;
    launchBtn.setAttribute("path", myPath);
    launchBtn.setAttribute("appid", "wxc8b38e1dc7de0c81");
    launchBtn.setAttribute("env-version", "trial");

    // 清空原有内容
    launchBtn.innerHTML = "";
    // 创建 script 标签
    const script = document.createElement("script");
    script.type = "text/wxtag-template";
    script.textContent = `
    <style>
      .btn {
        background-color: white;
        border-radius: 10px;
        color: ${this.appData.merThemeColor};
        font-size: 16px;
        height: 50px;
        padding: 25px 80px;
        white-space: nowrap;
        display: flex;
        align-items: center;
        justify-content: center;
        border: none;
      }
    </style>
    <button class="btn">进入控制台</button>
  `;
    launchBtn.appendChild(script);
    //配置微信授权
    this.uppdateWXConfigAction();
  },

  methods: {
    uppdateWXConfigAction() {
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });

      getWXAuthInfor().then((res) => {
        this.$wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.appId, // 必填，公众号的唯一标识
          timestamp: res.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.noncestr, // 必填，生成签名的随机串
          signature: res.signature, // 必填，签名
          jsApiList: ["scanQRCode"], // 必填，随意一个接口即可
          openTagList: ["wx-open-launch-weapp"], // 填入打开小程序的开放标签名
        });
        this.$wx.ready(() => {
          this.$toast.clear();
        });
      });
    },
  },
};
</script>
